import { render } from "./SearchView.vue?vue&type=template&id=4035a7da&scoped=true"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"

import "./SearchView.vue?vue&type=style&index=0&id=4035a7da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4035a7da"]])

export default __exports__